import "@/base";

import "@/stylesheets/user_application.scss";

import setupCategorizedTagControl from "@/categorized_tag_control";
import setupGroupedTagToCategory from "@/grouped_tag_control";
import "@/job-card";
import "@/projects";
import "@/projects-sort";
import "@/users-profile";
import "@/autokana";
import "@/project_scroll";
import "@/input_start_time_date";
import "@/scout_decline";
import "@/user_apply_thanks_modal";
import "@/user_resumes";
import "@nathanvda/cocoon";
import "@/js/users/top_animation";
import "@/js/users/top_projects_swiper";
import "@/js/users/header";

window.setupCategorizedTagControl = setupCategorizedTagControl;
window.setupGroupedTagToCategory = setupGroupedTagToCategory;
